import { render, staticRenderFns } from "./WalletAccount.vue?vue&type=template&id=1600df04&lang=pug"
import script from "./WalletAccount.vue?vue&type=script&lang=js"
export * from "./WalletAccount.vue?vue&type=script&lang=js"
import style0 from "./WalletAccount.vue?vue&type=style&index=0&id=1600df04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports